<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 09:59:15
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-28 19:30:03
-->
<template>
  <div id="app">
    <div v-if="isMe">
      <keep-alive>
        <router-view v-if="$route.meta && $route.meta.keepAlive">
        </router-view>
      </keep-alive>
      <router-view v-if="$route.meta && !$route.meta.keepAlive">
      </router-view>
    </div>
    <div v-else class="forbid">
      <div class="forbid-bg"></div>
      <div class="forbid-tip">请在京ME中查看</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      // 判断是否在京me环境
      isMe: window.navigator.userAgent.indexOf('JDME') > -1
              || window.location.href.indexOf('local') > -1
              || window.location.href.indexOf('isHideShareButton') > -1 
              || window.location.href.indexOf('yearReport') > -1 || window.location.href.indexOf('programmer-day-2026')
    }
  },
  created() {
    if (this.$route.name !== '403') {
      this.updateUserInfo()
      this.updateAvatarList()
      this.updateNameList()
    }
  },
  methods: {
    ...mapActions(['updateUserInfo', 'updateAvatarList', 'updateNameList'])
  }
}
</script>

<style lang="less">
#app {
  font-family: GoogleSans, PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: #f0f2f5;
  color: #232930;
  min-height: 100vh;
  line-height: 1.5;
  /* padding-bottom: 24px; */
}
p {
  margin: 0;
  line-height: 1.5715;
}
.forbid {
  width: 100%;
  height: 100vh;
  background-color:#fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.forbid-bg {
  margin-top: 150px;
  width: 320px;
  height: 130px;
  background: url(https://storage.jd.com/iast-agent/shendeng/forbid.png) no-repeat center center;
  background-size: contain;
}
.forbid-tip {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}
.w-e-bar-item .disabled {
  color: #bbb;
}
.w-e-bar-item .disabled svg {
  fill: #bbb;
}
.w-e-bar-item .disabled:hover {
  color: #bbb;
}
&[data-w-e-type='mention'] {
  margin-left: 3px;
  margin-right: 3px;
  background-color: #f5f2f0;
  border: 2px solid transparent;
  border-radius: 3px;
  padding: 0 3px;
}
</style>
